import { useState } from 'react';
import type { ErrorField } from '../types/ErrorField';
import type { UpdateJudicialDepositPayload } from '../types/LegalCase';

// Campos com binding próprio no formulário de levantamento.
const INLINE_FIELDS = new Set(['withdrawnAmount', 'withdrawnAt']);

export const residualWithdrawalErrors = (errorFields: ErrorField[]): ErrorField[] =>
    errorFields.filter((e) => !INLINE_FIELDS.has(e.fieldName));

const moneyOrUndefined = (value: number): number | undefined =>
    value && value > 0 ? value : undefined;

interface UseLegalCaseWithdrawalFormArgs {
    onSubmit: (value: UpdateJudicialDepositPayload) => Promise<boolean>;
}

// Estado e handlers do formulário de levantamento (edição do depósito: valor + data do
// alvará), fora do componente. Valor e data andam juntos — a coerência é validada no backend
// (422), então o botão fica sempre habilitado. Centraliza o reset ao enviar com sucesso.
export default function useLegalCaseWithdrawalForm({ onSubmit }: UseLegalCaseWithdrawalFormArgs) {
    const [withdrawnAmount, setWithdrawnAmount] = useState(0);
    const [withdrawnAt, setWithdrawnAt] = useState('');

    const reset = () => {
        setWithdrawnAmount(0);
        setWithdrawnAt('');
    };

    const canSubmit = true;

    const submit = async () => {
        const ok = await onSubmit({
            withdrawnAmount: moneyOrUndefined(withdrawnAmount),
            withdrawnAt: withdrawnAt.trim() || undefined,
        });
        if (ok) reset();
    };

    return {
        withdrawnAmount, setWithdrawnAmount,
        withdrawnAt, setWithdrawnAt,
        canSubmit, submit, reset,
    };
}
